
import { Component, Prop, Vue } from "vue-property-decorator";
import dayjs from "dayjs";
import PreviewGoodsItem from "./PreviewGoodsItem.vue";
import { JielongGoodsItem } from "@/api/jielong";

const WEEK_LABELS = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

@Component({ components: { PreviewGoodsItem } })
export default class PreviewGoodsSection extends Vue {
  @Prop({ type: Array, default: () => [] }) goods!: JielongGoodsItem[];
  @Prop({ type: String, default: "" }) createTime!: string;
  @Prop({ type: String, default: "" }) arrivalTime!: string;
  @Prop({ type: Boolean, default: false }) isDetailMode!: boolean;

  get arrivalText (): { date: string; daysLater: string } | null {
    if (!this.arrivalTime) return null;
    const arrival = dayjs(this.arrivalTime);
    if (!arrival.isValid()) return null;
    const week = WEEK_LABELS[arrival.day()];
    const date = `${arrival.format("MM月DD日")}(${week})到货`;
    const diff = arrival.startOf("day").diff(dayjs().startOf("day"), "day");
    let daysLater = "";
    if (diff > 0) {
      daysLater = `${diff}天后`;
    } else if (diff === 0) {
      daysLater = "今天";
    }
    return { date, daysLater };
  }
}
